// Shared fixed body height for tables shown side-by-side in a two-column row, so both
// sit at the same height — the longer one scrolls internally instead of either stretching.
export const PAIRED_TABLE_BODY_HEIGHT = '420px'

export const formatCurrency = (val: number) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(val)
}

export const formatDate = (val: string) => {
  return new Date(val).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

export const formatMT = (val: number) => {
  if (val === undefined || val === null || Number.isNaN(val)) return '0'
  return Number(val.toFixed(4)).toString()
}
